import { createFileRoute } from "@tanstack/react-router";

import { DonationForm } from "@/components/forms/DonationForm";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { PageHero } from "@/components/layout/PageHero";
import { heroFor } from "@/data/heroes";
import { DonateTabs } from "@/components/sections/DonateTabs";

const TITLE = "Monthly Recurring Donation — Light of Life International";
const DESCRIPTION =
  "Become a monthly partner with Light of Life International and help sustain crusades and compassion ministry year round.";

export const Route = createFileRoute("/donation-form_/monthly-recurring")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://loli.ardent.dev/donation-form/monthly-recurring" },
    ],
    links: [{ rel: "canonical", href: "https://loli.ardent.dev/donation-form/monthly-recurring" }],
  }),
  component: MonthlyRecurringPage,
});

function MonthlyRecurringPage() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />
      <PageHero
        title="Monthly Recurring"
        image={heroFor("/donation-form/monthly-recurring").image}
        subtitle="They desired only that we should remember the poor, the very thing which I also was eager to do."
        attribution="Galations 2:10"
      />

      <main id="main" className="flex-1">
        <section
          className="section-y bg-white bg-right-top bg-no-repeat"
          style={{ backgroundImage: "url(/media/imageye___-_imgi_8_backgroundpattern-tr.png)" }}
        >
          <div className="container-site">
            <h2 className="text-center text-4xl text-navy sm:text-5xl">Donate Now</h2>
            <DonateTabs active="monthly" />
            <h3 className="mt-8 text-3xl text-navy sm:text-4xl">Monthly Recurring Payment</h3>
            <DonationForm frequency="monthly" />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
